import { useState } from "react";
import { sendQuickEmail } from "../../../api/contacts";
import toast from "react-hot-toast";
import { FiSend } from "react-icons/fi";

export default function QuickSend({ token, templateId, setResult, trackOpens = false, includeUnsubscribe = false }) {
  const [emails, setEmails] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailList = emails.split(",").map((e) => e.trim()).filter(Boolean);

    try {
      const res = await sendQuickEmail(token.access, emailList, templateId, trackOpens, includeUnsubscribe);
      setResult(res);
      toast.success("Emails sent!");
    } catch {
      toast.error("Failed");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSend} className="bg-white p-6 rounded-lg shadow-sm border space-y-4">
      <label className="text-sm font-semibold">Emails (comma separated)</label>
      <textarea
        value={emails}
        onChange={(e) => setEmails(e.target.value)}
        placeholder="user1@test.com, user2@test.com"
        className="border p-3 rounded w-full"
        required
        rows={4}
      />

      <button
        type="submit"
        className="bg-blue-600 text-white px-6 py-2 rounded flex items-center gap-2"
        disabled={loading}
      >
        <FiSend /> {loading ? "Sending..." : "Send"}
      </button>
    </form>
  );
}
